import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { NavigationService } from '@core/navigation/navigation.service';
import { Navigation } from '@core/navigation/navigation.types';
import { cdcMenu, spaceHeaderClass, spaceSidebarClass } from '@core/spaces/spaces.types';
import { FuseNavigationItem } from '@fuse/components/navigation';
import { environment } from 'environments/environment';
import { BehaviorSubject, filter, finalize, first, map, Observable, of, ReplaySubject, switchMap, tap } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class SpaceService {
    private _allSpaces: BehaviorSubject<string[]> = new BehaviorSubject<string[]>(null);

    constructor(private _httpClient: HttpClient, private _navigationService: NavigationService) { }

    get allSpaces$(): Observable<string[]> {
        return this._allSpaces.asObservable();
    }

    private _allSpaceComputing: boolean = false
    getAllSpace(): Observable<string[]> {
        if (this._allSpaces.value) {
            return of(this._allSpaces.value)
        }

        return of(null).pipe(
            switchMap(_ => {
                if (this._allSpaceComputing) {
                    return this._allSpaces.pipe(filter(v => v != null), first())
                }
                else {
                    this._allSpaceComputing = true
                    return this._httpClient.get<string[]>(environment.server + 'api/admin/spaces').pipe(finalize(() => this._allSpaceComputing = false), tap(r => this._allSpaces.next(r)))
                }
            })
        )
    }


    private currentSpace = new ReplaySubject<string>(1)
    private currentSpaceMenu = new ReplaySubject<Navigation>(1)
    private currentSpaceHeaderClass = new ReplaySubject<string>(1)
    private currentSpaceSidebarClass = new ReplaySubject<string>(1)

    currentSpace$ = this.currentSpace.asObservable()
    currentSpaceMenu$ = this.currentSpaceMenu.asObservable()
    currentSpaceHeaderClass$ = this.currentSpaceHeaderClass.asObservable()
    currentSpaceSidebarClass$ = this.currentSpaceSidebarClass.asObservable()



    private _setSpace(s: string): Observable<boolean> {
        return of(null).pipe(
            switchMap(_ => {
                if (s == "normal") {
                    this.currentSpace.next("normal")
                    this.currentSpaceHeaderClass.next(spaceHeaderClass[s])
                    this.currentSpaceSidebarClass.next(spaceSidebarClass[s])
                    return of(true)
                }
                return this.getAllSpace().pipe(
                    map(allSpaces => {
                        const found = allSpaces.includes(s)
                        if (found) {
                            this.currentSpace.next(s)
                            this.currentSpaceHeaderClass.next(spaceHeaderClass[s])
                            this.currentSpaceSidebarClass.next(spaceSidebarClass[s])
                        }
                        return found
                    }))
            })
        )

    }

    setSpace(s: string): Observable<boolean> {
        console.log("Setting space to " + s)
        return this._setSpace(s).pipe(switchMap(
            r => {
                if (r) {
                    return this.getSpaceMenu(s).pipe(
                        tap(m => {
                            this.currentSpaceMenu.next(m)
                        }),
                        map(_ => true)
                    )
                }
                return of(r)
            }
        ))
    }



    getSpaceMenu(s: string): Observable<Navigation> {
        if (s == "CDC") {

            return of({
                compact: cdcMenu,
                default: cdcMenu,
                futuristic: cdcMenu,
                horizontal: cdcMenu,
            } as Navigation)
        }
        return this._navigationService.get()
    }
}
